/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { withRouter } from 'react-router';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { Button } from 'react-bootstrap';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';
import DateFnsUtils from '@date-io/date-fns';
import { useDispatch, useSelector } from 'react-redux';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import moment from 'moment';
import _ from 'lodash';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import Grid from '../../../../SharedModules/Table/TableGridWithFeatures';
import { manuFactureHead } from '../../../../SharedModules/Table/tableHead';
import {
  freezeInvoice,
  getMaxQuarterForFreezeDt,
  dispatchFreezeInvoiceSaveRes,
  setFreezeInvoiceData,
  setErrorMessages,
  getManufacturersForFreezeInv,
} from '../Store/actions';
import {
  checkQuarterValidation,
  handleScrollToEvent,
  quarterFormatter,
  validDate,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import * as CONSTANTS from '../../../../SharedModules/AppConstants';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import {
  checkForValidDateString,
  compareTwoDatesGreaterThanOrEqual,
} from '../../../../SharedModules/DateUtilities/DateUtilities';
import {
  MinDate,
  dateFormatForDatePicker,
  radioGroupLabelNamePlan,
} from '../../../../SharedModules/CommonConstants/commonConstants';
import {
  autoFormateDate,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';
import {
  getPlanTypeRadioBoxValue,
  getRebateProgramDropdownList,
} from '../../../Research/UnderThresholdInvoices/store/Actions';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';

function FreezeInvoice() {
  const dispatch = useDispatch();
  const errorMsgsStore = useSelector(
    (state) => state.sharedState.FreezeInvoiceReducer?.errorMsgsStore
  );

  const defaultQtrFreezeInv = useSelector(
    (state) => state.sharedState.FreezeInvoiceReducer?.defaultQtrFreezeInv?.data
  );

  const manufacturersByPQR = useSelector(
    (state) => state.sharedState.FreezeInvoiceReducer?.manufacturersByPQR
  );

  const reqFreezeInvoiceData = useSelector(
    (state) => state.sharedState.FreezeInvoiceReducer?.reqRecordMailingData
  );

  const UserDefaultValues = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues.data
  );

  const saveOrUpdateMessage = useSelector(
    (state) => state.sharedState.FreezeInvoiceReducer?.freezeInvoiceRes
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const gridRef = useRef();
  const [successMessages, setSuccessMessages] = useState([]);
  const [selected, setSelected] = useState(null);
  const [fullScreenView, setFullScreenView] = useState(false);
  const [runOption, setRunOption] = useState('');
  const [gridApi, setGridApi] = useState(gridRef);
  const [showViewHistory, setShowViewHistory] = useState(false);
  const [keyValue, setKeyValue] = useState([]);
  const [enteredInvoiceNum, setEnteredInvoiceNum] = useState('');
  const [rebateProgramList, setRebateProgramList] = React.useState([]);
  const [planTypeOptions, setPlanTypeOptions] = React.useState([]);

  const isNumber = (evt) => {
    evt = evt || window.event;
    const charCode = evt.which ? evt.which : evt.keyCode;
    if ((charCode !== 8 && charCode !== 0 && charCode < 48) || charCode > 57) {
      evt.preventDefault();
      // dispatch(setErrorMessages(['Invalid Invoice Number']));
      return false;
    }
    dispatch(setErrorMessages([]));
    return true;
  };
  // set common dropdown list after calling API service
  React.useEffect(() => {
    if (reqFreezeInvoiceData?.planType) {
      getRebateProgramDropdownList(reqFreezeInvoiceData?.planType).then(
        (res) => {
          let list = [];
          if (
            res?.status === constantMessageData.STATUS_MSG &&
            res?.message === constantMessageData.SUCCESS_MSG
          ) {
            if (!_.isEmpty(res.data)) {
              list = _.map(res.data, (val) => ({
                ...val,
                id: val.rebateProgramCd,
                name: `${val.rebateProgramCd} | ${val.shortDescr}`,
              }));
            }
          }
          setRebateProgramList(
            list.sort((key, val) =>
              key.name.toLowerCase().localeCompare(val.name.toLowerCase())
            )
          );
        }
      );
    }
  }, [reqFreezeInvoiceData?.planType]);
  // set play type Radio Data List for page load
  React.useEffect(() => {
    getPlanTypeRadioBoxValue().then((res) => {
      const planList =
        res?.length > 0 &&
        res?.map((obj) => {
          return {
            name:
              obj?.codeValueID?.codeValue === 'FD'
                ? 'Medicaid'
                : obj.shortDescription,
            value: obj.codeValueID.codeValue,
          };
        });
      setPlanTypeOptions(planList);
    });
    handleScrollToEvent();
  }, []);

  // useEffect(() => {
  //   dispatch(getMaxQuarterForFreezeDt());
  //   dispatch(dispatchFreezeInvoiceSaveRes({}));
  //   dispatch(
  //     setFreezeInvoiceData({
  //       ...reqFreezeInvoiceData,
  //       quarter:
  //         reqFreezeInvoiceData?.quarter == null
  //           ? defaultQtrFreezeInv
  //           : reqFreezeInvoiceData?.quarter,
  //       freezeInvoiceBy: !reqFreezeInvoiceData?.freezeInvoiceBy
  //         ? UserDefaultValues?.defInvoiceSelectModeCd
  //         : reqFreezeInvoiceData?.freezeInvoiceBy,
  //       // planType: !reqFreezeInvoiceData?.planType
  //       //   ? UserDefaultValues?.planTypeCd
  //       //   : reqFreezeInvoiceData?.planType,
  //       // rebateProgramCode: !reqFreezeInvoiceData?.rebateProgramCode
  //       //   ? UserDefaultValues?.rebateProgramCd
  //       //   : reqFreezeInvoiceData?.rebateProgramCode,
  //       planType:
  //         (UserDefaultValues && UserDefaultValues?.planTypeCd) ||
  //         reqFreezeInvoiceData?.planType,
  //       rebateProgramCode:
  //         (UserDefaultValues && UserDefaultValues?.rebateProgramCd) ||
  //         reqFreezeInvoiceData?.rebateProgramCode,
  //     })
  //   );
  // }, []);
  // React.useEffect(() => {
  //   if (reqFreezeInvoiceData.freezeInvoiceBy === undefined) {
  //     dispatch(
  //       setFreezeInvoiceData({
  //         ...reqFreezeInvoiceData,
  //         freezeInvoiceBy: 'PQM',
  //       })
  //     );
  //   }
  // }, [reqFreezeInvoiceData.freezeInvoiceBy]);
  useEffect(() => {
    if (manufacturersByPQR?.data) {
      if (manufacturersByPQR?.data.length > 0) {
        if (
          gridApi?.getRowNode &&
          gridApi?.getRowNode.length > 0 &&
          gridApi?.getRowNode(0)
        ) {
          setSelected(gridApi.getRowNode(0).data?.mfgId || []);
          gridApi.getRowNode(0).selectThisNode(true);
        }
      }
    }
  }, [manufacturersByPQR]);

  // useEffect(() => {
  //   if (defaultQtrFreezeInv) {
  //     dispatch(
  //       setFreezeInvoiceData({
  //         ...reqFreezeInvoiceData,
  //         quarter:
  //           reqFreezeInvoiceData?.quarter == null
  //             ? defaultQtrFreezeInv
  //             : reqFreezeInvoiceData?.quarter,
  //       })
  //     );
  //   }
  // }, [defaultQtrFreezeInv]);

  React.useEffect(() => {
    dispatch(getMaxQuarterForFreezeDt());
    dispatch(dispatchFreezeInvoiceSaveRes({}));

    const initialData = {
      ...reqFreezeInvoiceData,
      quarter:
        reqFreezeInvoiceData?.quarter == null
          ? defaultQtrFreezeInv
          : reqFreezeInvoiceData?.quarter,
      freezeInvoiceBy:
        reqFreezeInvoiceData?.freezeInvoiceBy ||
        UserDefaultValues?.defInvoiceSelectModeCd ||
        'PQM',
      planType: reqFreezeInvoiceData?.planType || UserDefaultValues?.planTypeCd,
      rebateProgramCode:
        reqFreezeInvoiceData?.rebateProgramCode ||
        UserDefaultValues?.rebateProgramCd,
    };

    dispatch(setFreezeInvoiceData(initialData));
  }, [dispatch, defaultQtrFreezeInv]);

  const formatDate = (date) => {
    return moment(new Date(date)).format('MM/DD/yyyy');
  };
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  useEffect(() => {
    if (
      saveOrUpdateMessage &&
      saveOrUpdateMessage?.message === 'Success' &&
      saveOrUpdateMessage?.status === '001'
    ) {
      if (runOption === 'N') {
        setSuccessMessages([CONSTANTS.INVOICE_JOB_COMPLETE]);
      } else if (runOption === 'L') {
        setSuccessMessages([CONSTANTS.INVOICE_JOB_DEFERED]);
      }
    } else if (
      saveOrUpdateMessage?.status === '002' &&
      saveOrUpdateMessage?.message === 'Error' &&
      saveOrUpdateMessage?.size > 0
    ) {
      const formatErrorMessage = saveOrUpdateMessage.data.join('\n');
      dispatch(
        setErrorMessages([
          {
            field: 'resultNotFound2',
            errorType: 'resultNotFound2',
            message: formatErrorMessage,
          },
        ])
      );
    } else if (
      reqFreezeInvoiceData.freezeInvoiceBy === 'PQM' &&
      saveOrUpdateMessage?.status === '002'
    ) {
      dispatch(
        setErrorMessages([
          {
            field: 'resultNotFound2',
            errorType: 'resultNotFound2',
            message: CONSTANTS.NO_MATHING_INVOICE,
          },
        ])
      );
      setSuccessMessages([]);
    } else if (
      (saveOrUpdateMessage?.errorMap === 'API failed' &&
        saveOrUpdateMessage?.status === '002') ||
      (saveOrUpdateMessage?.status === '002' &&
        saveOrUpdateMessage?.errorMap == null)
    ) {
      dispatch(
        setErrorMessages([
          {
            field: 'InvNumNotFrozen',
            errorType: 'invoiceNum',
            message: `${CONSTANTS.INVOICE_NOT_FOUND}. Invoice: #${enteredInvoiceNum}`,
          },
        ])
      );
    }
    if (
      reqFreezeInvoiceData.freezeInvoiceBy === 'IN' &&
      saveOrUpdateMessage?.status === '002' &&
      saveOrUpdateMessage?.message === 'Error' &&
      saveOrUpdateMessage?.size > 0
    ) {
      dispatch(
        setErrorMessages([
          {
            field: 'InvNumNotFrozen',
            errorType: 'invoiceNum',
            message: saveOrUpdateMessage && saveOrUpdateMessage?.data[0],
          },
        ])
      );
    }
  }, [saveOrUpdateMessage]);

  const onCellClicked = (e) => {
    setSelected(e.data.mfgId);
  };

  const validateInvoiceCalcReq = () => {
    setSuccessMessages([]);

    let localErr = [];
    let showError = false;
    if (
      reqFreezeInvoiceData.freezeDate === '' ||
      reqFreezeInvoiceData.freezeDate == null
    ) {
      localErr = localErr?.filter((item) => {
        return (
          item.field !== 'dateFormatInvalid' &&
          item.field !== 'compareDateGreater' &&
          item.field !== 'notSelectedMFG'
        );
      });
      showError = true;
      localErr.push({
        field: 'freezeDateRequired',
        errorType: 'freezeDate',
        message: constantMessageData.FREEZE_DT_REQ,
      });
    } else if (
      reqFreezeInvoiceData.freezeDate &&
      validDate(new Date(reqFreezeInvoiceData.freezeDate)) === false
    ) {
      localErr = localErr?.filter((item) => {
        return (
          item.field !== 'compareDateGreater' &&
          item.field !== 'freezeDateRequired' &&
          item.field !== 'notSelectedMFG'
        );
      });
      showError = true;
      localErr.push({
        field: 'dateFormatInvalid',
        errorType: 'freezeDate',
        message: constantMessageData.DATE_INVALID_FORMAT_ERROR,
      });
    } else if (
      reqFreezeInvoiceData.freezeDate &&
      compareTwoDatesGreaterThanOrEqual(
        reqFreezeInvoiceData.freezeDate,
        moment(MinDate)
      )
    ) {
      localErr = localErr?.filter((item) => {
        return (
          item.field !== 'dateFormatInvalid' &&
          item.field !== 'freezeDateRequired' &&
          item.field !== 'notSelectedMFG'
        );
      });
      showError = true;
      localErr.push({
        field: 'compareDateGreater',
        errorType: 'freezeDate',
        message: constantMessageData.MINIMUM_FREEZE_DT,
      });
    }
    if (!showError) {
      localErr = localErr?.filter((item) => {
        return (
          item.field !== 'dateFormatInvalid' &&
          item.field !== 'compareDateGreater' &&
          item.field !== 'freezeDateRequired' &&
          item.field !== 'notSelectedMFG'
        );
      });
    }
    if (reqFreezeInvoiceData.freezeInvoiceBy === 'PQM') {
      if (
        reqFreezeInvoiceData.rebateProgramCode === '' ||
        reqFreezeInvoiceData.rebateProgramCode === undefined ||
        reqFreezeInvoiceData.rebateProgramCode === '-1'
      ) {
        localErr = localErr?.filter((item) => item.filed !== 'resultNotFound2');
        localErr.push({
          field: 'rebateProgramCode',
          errorType: 'rebateRequired',
          message: constantMessageData.REBATE_PROGRAM_REQUIRED,
        });
      }
      if (reqFreezeInvoiceData.quarter === '') {
        localErr = localErr.filter(
          (item) => item.field !== 'quarter' && item.filed !== 'resultNotFound2'
        );
        localErr.push({
          field: 'quarter',
          errorType: 'required',
          message: constantMessageData.QUARTER_VALUE_REQUIRED,
        });
      } else if (!checkQuarterValidation(reqFreezeInvoiceData.quarter)) {
        localErr = localErr.filter(
          (item) => item.field !== 'quarter' && item.filed !== 'resultNotFound2'
        );
        localErr.push({
          field: 'quarter',
          errorType: 'invalidFormat',
          message: constantMessageData.REQUEST_DATE_INVALID_FORMAT_CBI,
        });
      }
    } else if (
      reqFreezeInvoiceData?.invoiceNum === null ||
      reqFreezeInvoiceData?.invoiceNum === ''
    ) {
      localErr.push({
        field: 'resultNotFound1',
        errorType: 'invoiceNum',
        message: constantMessageData.INVOICE_NUM_REQ,
      });
    }

    dispatch(setErrorMessages([...new Set(localErr)]));
    return !localErr.length > 0;
  };
  // handing highlight tab
  React.useEffect(() => {
    if (errorMsgsStore && errorMsgsStore.length > 0) {
      tabHighLigther('/freezeInvoice', true);
    } else {
      tabHighLigther('/freezeInvoice', false);
    }
  }, [JSON.stringify(errorMsgsStore)]);
  const handleDate = (e, isDate) => {
    if (isDate === 'freezeDate' && e) {
      dispatch(
        setFreezeInvoiceData({
          ...reqFreezeInvoiceData,
          freezeDate: new Date(e),
        })
      );
    } else {
      dispatch(
        setFreezeInvoiceData({
          ...reqFreezeInvoiceData,
          freezeDate: null,
        })
      );
    }
  };

  const handleFreezeInvoiceData = (e) => {
    dispatch(setErrorMessages([]));
    setSuccessMessages([]);
    if (e.target.name === 'freezeInvoiceBy') {
      setSelected(null);
    }
    if (e.target.name === 'allManufacturers') {
      if (e.target.checked) {
        setSelected(null);
      }
      dispatch(
        setFreezeInvoiceData({
          ...reqFreezeInvoiceData,
          [e.target.name]: e.target.checked,
        })
      );
    } else {
      dispatch(
        setFreezeInvoiceData({
          ...reqFreezeInvoiceData,
          [e.target.name]: e.target.value,
          ...('planType' in reqFreezeInvoiceData &&
            e.target.name === 'planType' && { rebateProgramCode: '-1' }),
        })
      );
      if (e.target.name === 'invoiceNum') {
        setEnteredInvoiceNum(e.target.value);
      }
    }
  };

  const searchManufacturers = () => {
    setSuccessMessages([]);

    if (validateInvoiceCalcReq(true)) {
      setSelected(null);
      dispatch(
        getManufacturersForFreezeInv({
          invQtr: reqFreezeInvoiceData.quarter,
          rebateProgramCd: reqFreezeInvoiceData.rebateProgramCode,
          planTypeCode:
            reqFreezeInvoiceData.planType === 'FD' ||
            reqFreezeInvoiceData.planType === 'ST'
              ? 'G'
              : 'C',
        })
      );
    }
  };

  const processFreezeInvoiceDate = (e, runOptionType) => {
    setRunOption(runOptionType);
    setSuccessMessages([]);
    const reqMailingDataPayload = {};
    if (validateInvoiceCalcReq()) {
      if (reqFreezeInvoiceData.freezeInvoiceBy === 'PQM') {
        reqMailingDataPayload.invQtr = reqFreezeInvoiceData?.quarter;
        reqMailingDataPayload.rebateProgramCd =
          reqFreezeInvoiceData?.rebateProgramCode;
        reqMailingDataPayload.planTypeCode = reqFreezeInvoiceData?.planType;
        reqMailingDataPayload.allRebatePrograms = 0;
        reqMailingDataPayload.allManufacturers =
          reqFreezeInvoiceData?.allManufacturers ? 'Yes' : 'No';
        if (!reqFreezeInvoiceData.allManufacturers && selected != null) {
          reqMailingDataPayload.mfgId = selected;
        }
        reqMailingDataPayload.runOption = runOptionType;
        reqMailingDataPayload.userId = logInUser;
        reqMailingDataPayload.freezeDate = formatDate(
          reqFreezeInvoiceData.freezeDate
        );
        reqMailingDataPayload.freezeInvoiceBy = 'NDC';
        reqMailingDataPayload.mfgTypeCd =
          reqFreezeInvoiceData?.planType === 'FD' ||
          reqFreezeInvoiceData?.planType === 'ST'
            ? 'G'
            : 'C';
      } else if (reqFreezeInvoiceData.freezeInvoiceBy === 'IN') {
        reqMailingDataPayload.runOption = runOptionType;
        reqMailingDataPayload.userId = logInUser;
        reqMailingDataPayload.invoiceNum = reqFreezeInvoiceData?.invoiceNum;
        reqMailingDataPayload.freezeDate = formatDate(
          reqFreezeInvoiceData.freezeDate
        );
        reqMailingDataPayload.freezeInvoiceBy = 'invoiceNum';
      }
      dispatch(freezeInvoice(reqMailingDataPayload));
    }
  };

  const handleViewHistory = () => {
    setShowViewHistory(true);
    setKeyValue({});
  };

  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
  }, []);
  // hading On blur event on filed level
  const handleOnblurEvent = (type, value) => {
    let localErr = errorMsgsStore || [];
    if (type === 'rebateProgramCode') {
      if (!value || value === '-1') {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'rebateProgramCode' &&
            item.field !== 'resultNotFound'
        );
        localErr.push({
          field: 'rebateProgramCode',
          errorType: 'rebateRequired',
          message: constantMessageData.REBATE_PROGRAM_REQUIRED,
        });
      } else {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'rebateProgramCode' &&
            item.field !== 'resultNotFound'
        );
      }
    }
    if (type === 'invoiceNum') {
      if (value === null || value === '') {
        localErr = [];
        localErr.push({
          field: 'resultNotFound1',
          errorType: 'invoiceNum',
          message: constantMessageData.INVOICE_NUM_REQ,
        });
      } else {
        localErr = [];
      }
    }
    if (type === 'quarter') {
      if (value && !_.isEmpty(value) && !_.isNaN(value)) {
        localErr = localErr?.filter(
          (item) => item.field !== 'quarter' && item.field !== 'resultNotFound'
        );
        if (checkQuarterValidation(value)) {
          localErr = localErr?.filter(
            (item) =>
              item.field !== 'quarter' && item.field !== 'resultNotFound'
          );

          dispatch(
            setFreezeInvoiceData({
              ...reqFreezeInvoiceData,
              quarter: autoFormateDate(value?.toUpperCase()),
            })
          );
        } else {
          localErr = localErr.filter(
            (item) =>
              item.field !== 'quarter' && item.field !== 'resultNotFound'
          );
          localErr.push({
            field: 'quarter',
            errorType: 'invalidFormat',
            message: constantMessageData.REQUEST_DATE_INVALID_FORMAT_CBI,
          });
        }
      } else {
        localErr = localErr.filter(
          (item) => item.field !== 'quarter' && item.field !== 'resultNotFound'
        );
        localErr.push({
          field: 'quarter',
          errorType: 'required',
          message: constantMessageData.QUARTER_VALUE_REQUIRED,
        });
      }
    }
    dispatch(setErrorMessages([...new Set(localErr)]));
  };
  // call on Blur event &OnChange even As of date filed level
  const handleOnBlurDateEvent = (d, event) => {
    let localErr = errorMsgsStore || [];
    if (d != 'Invalid Date') {
      let value = null;
      if (event === 'onBlur' && d.target.value && d.target.value.length > 5) {
        const data = d.target.value.split('/');
        if (data[2].split('_').length === 3) {
          value = moment(d.target.value, 'MM/DD/YY').format('MM/DD/YYYY');
        } else {
          value = d.target.value;
        }
      } else {
        value = event === 'onBlur' ? d.target.value : d;
      }
      let showError = false;
      if (value === null || value === '') {
        localErr = localErr?.filter((item) => {
          return (
            item.field !== 'dateFormatInvalid' &&
            item.field !== 'compareDateGreater' &&
            item.field !== 'notSelectedMFG'
          );
        });
        showError = true;
        localErr.push({
          field: 'freezeDateRequired',
          errorType: 'freezeDate',
          message: constantMessageData.FREEZE_DT_REQ,
        });
        dispatch(
          setFreezeInvoiceData({
            ...reqFreezeInvoiceData,
            freezeDate: value,
          })
        );
      } else if (validDate(new Date(value)) === false) {
        localErr = localErr?.filter((item) => {
          return (
            item.field !== 'compareDateGreater' &&
            item.field !== 'freezeDateRequired' &&
            item.field !== 'notSelectedMFG'
          );
        });
        showError = true;
        localErr.push({
          field: 'dateFormatInvalid',
          errorType: 'freezeDate',
          message: constantMessageData.DATE_INVALID_FORMAT_ERROR,
        });
        dispatch(
          setFreezeInvoiceData({
            ...reqFreezeInvoiceData,
            freezeDate: value,
          })
        );
      } else if (compareTwoDatesGreaterThanOrEqual(value, moment(MinDate))) {
        localErr = localErr?.filter((item) => {
          return (
            item.field !== 'dateFormatInvalid' &&
            item.field !== 'freezeDateRequired' &&
            item.field !== 'notSelectedMFG'
          );
        });
        showError = true;
        localErr.push({
          field: 'compareDateGreater',
          errorType: 'freezeDate',
          message: constantMessageData.MINIMUM_FREEZE_DT,
        });
        dispatch(
          setFreezeInvoiceData({
            ...reqFreezeInvoiceData,
            freezeDate: value,
          })
        );
      }
      if (!showError) {
        localErr = localErr?.filter((item) => {
          return (
            item.field !== 'dateFormatInvalid' &&
            item.field !== 'compareDateGreater' &&
            item.field !== 'freezeDateRequired' &&
            item.field !== 'notSelectedMFG'
          );
        });
        dispatch(
          setFreezeInvoiceData({
            ...reqFreezeInvoiceData,
            freezeDate: autoFormateDate(value),
          })
        );
      }
      dispatch(setErrorMessages([...new Set(localErr)]));
    }
  };

  return (
    <div className="tBillPanel custom-check">
      <div className="panel tBillPanel-space devider-line pb-0">
        {spinnerLoader && <Spinner load={spinnerLoader} />}
        <CustomSeparator parent1="Invoice" parent2="Freeze Invoices" />
        {!fullScreenView && (
          <>
            <DisplayErrorMessages
              errorMessages={[
                ...new Set(
                  errorMsgsStore?.filter((x) => {
                    if (reqFreezeInvoiceData?.freezeInvoiceBy === 'IN') {
                      return (
                        x.errorType === 'invoiceNum' ||
                        x.errorType === 'freezeDate'
                      );
                    }
                    return x.errorType !== 'invoiceNum';
                  })?.length > 0
                    ? _.map(
                        errorMsgsStore?.filter((x) => {
                          if (reqFreezeInvoiceData?.freezeInvoiceBy === 'IN') {
                            return (
                              x.errorType === 'invoiceNum' ||
                              x.errorType === 'freezeDate'
                            );
                          }
                          return x.errorType !== 'invoiceNum';
                        }),
                        (l) => l.message
                      )
                    : []
                ),
              ]}
            />
            <DisplaySuccessMessages successMessages={successMessages} />
            <div className="panel mb-3">
              <div className="row">
                <div className="col-sm-8">
                  <fieldset className="custom-fieldset">
                    <legend className="same-font-family" id="select_by_label">
                      Select by<span className="mandatory"> *</span>{' '}
                    </legend>
                    <div className="form-wrapper p-0 mt-2">
                      <div className="mui-custom-form input-md field-xl">
                        <div className="sub-radio no-margin">
                          <FormControl>
                            <RadioGroup
                              row
                              aria-labelledby="select_by_label"
                              name="freezeInvoiceBy"
                              value={
                                reqFreezeInvoiceData.freezeInvoiceBy || 'PQM'
                              }
                              onChange={handleFreezeInvoiceData}
                            >
                              <FormControlLabel
                                style={{ marginRight: '10px' }}
                                value="PQM"
                                label="Program,Quarter,Manufacturer"
                                data-test="Program/Quarter"
                                control={
                                  <Radio
                                    onChange={(e) => {
                                      handleFreezeInvoiceData(e);
                                    }}
                                  />
                                }
                              />
                              <FormControlLabel
                                style={{ marginRight: '10px' }}
                                value="IN"
                                label="Invoice Number"
                                data-test="Invoice Number"
                                control={
                                  <Radio
                                    onChange={(e) => {
                                      handleFreezeInvoiceData(e);
                                    }}
                                  />
                                }
                              />
                            </RadioGroup>
                          </FormControl>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </div>

                <div className="col-sm-4">
                  <fieldset className="custom-fieldset">
                    <legend className="same-font-family" id="freeze_date_label">
                      Freeze Date<span className="mandatory"> *</span>{' '}
                    </legend>

                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <div className="mui-custom-form with-select field-xl no-lbl">
                        <KeyboardDatePicker
                          required
                          data-test="start-date"
                          mask="__/__/____"
                          className="mandate-fields"
                          id="begindate-picker-dialog"
                          aria-labelledby="freeze_date_label"
                          format={dateFormatForDatePicker}
                          placeholder="mm/dd/yyyy"
                          name="freezeDate"
                          value={reqFreezeInvoiceData?.freezeDate || null}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            readOnly: false,
                            autoFill: false,
                          }}
                          inputProps={{
                            'aria-labelledby': 'freeze_date_label',
                          }}
                          KeyboardButtonProps={{
                            'aria-label': 'change date',
                          }}
                          onChange={(e) => {
                            handleDate(e, 'freezeDate');
                          }}
                          onBlur={(e) => {
                            handleOnBlurDateEvent(e, 'onBlur');
                          }}
                          helperText={
                            errorMsgsStore?.length > 0
                              ? [
                                  ...new Set(
                                    errorMsgsStore
                                      ?.filter((x) => {
                                        return (
                                          x.field === 'compareDateGreater' ||
                                          x.field === 'freezeDateRequired' ||
                                          x.field === 'dateFormatInvalid'
                                        );
                                      })
                                      .map((item) => {
                                        return item.message;
                                      })
                                  ),
                                ]
                              : null
                          }
                          error={
                            errorMsgsStore?.length > 0 &&
                            errorMsgsStore?.filter((x) => {
                              return (
                                x.field === 'compareDateGreater' ||
                                x.field === 'freezeDateRequired' ||
                                x.field === 'dateFormatInvalid'
                              );
                            }).length > 0
                              ? [
                                  ...new Set(
                                    errorMsgsStore
                                      ?.filter((x) => {
                                        return (
                                          x.field === 'compareDateGreater' ||
                                          x.field === 'freezeDateRequired' ||
                                          x.field === 'dateFormatInvalid'
                                        );
                                      })
                                      .map((item) => {
                                        return item.message;
                                      })
                                  ),
                                ]
                              : false
                          }
                        />
                      </div>
                    </MuiPickersUtilsProvider>
                  </fieldset>
                </div>
              </div>
              {reqFreezeInvoiceData.freezeInvoiceBy === 'PQM' && (
                <div className="row">
                  <div className="col-sm-4">
                    <RadioGroupComponent
                      data-testid="filter-plan-by-radio-btn-plan"
                      id="filter-plan-by-radio-btn-action"
                      labelName={radioGroupLabelNamePlan}
                      required
                      reqColor
                      applyStyle
                      optionList={planTypeOptions}
                      defaultValue={reqFreezeInvoiceData?.planType}
                      filterAction={(e) => {
                        handleFreezeInvoiceData({
                          target: {
                            name: 'planType',
                            value: e,
                          },
                        });
                      }}
                      className="log-batch-filter-radio"
                    />
                  </div>
                  <div className="col-sm-4">
                    <fieldset className="custom-fieldset">
                      <legend
                        className="same-font-family"
                        id="rebate_program_code_label"
                      >
                        Rebate Program<span className="mandatory"> *</span>{' '}
                      </legend>
                      <div className="form-wrapper p-0">
                        <div className="mui-custom-form with-select field-xl no-lbl">
                          <TextField
                            fullWidth
                            select
                            placeholder=""
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              'aria-labelledby': 'rebate_program_code_label',
                            }}
                            required
                            onChange={handleFreezeInvoiceData}
                            name="rebateProgramCode"
                            aria-labelledby="rebate_program_code_label"
                            value={reqFreezeInvoiceData?.rebateProgramCode}
                            onBlur={(e) =>
                              handleOnblurEvent(
                                'rebateProgramCode',
                                e.target.value
                              )
                            }
                            className={
                              errorMsgsStore?.length > 0
                                ? _.map(errorMsgsStore, (l) =>
                                    l.field === 'rebateProgramCode'
                                      ? 'mandate-fields'
                                      : null
                                  )
                                : null
                            }
                            helperText={
                              errorMsgsStore?.length > 0
                                ? _.map(errorMsgsStore, (l) =>
                                    l.field === 'rebateProgramCode'
                                      ? l.message
                                      : null
                                  )
                                : null
                            }
                            error={
                              errorMsgsStore?.length > 0
                                ? _.map(errorMsgsStore, (l) =>
                                    l.field === 'rebateProgramCode'
                                      ? l.message
                                      : null
                                  )
                                : null
                            }
                          >
                            <MenuItem
                              key=""
                              value="-1"
                              className="frr-dropdown-blank-item"
                            />
                            {rebateProgramList && rebateProgramList?.length > 0
                              ? rebateProgramList.map((item) => {
                                  return (
                                    <MenuItem
                                      key={item.rebateProgramCd}
                                      value={item.rebateProgramCd}
                                    >
                                      {item.rebateProgramCd} {'|'}{' '}
                                      {item.shortDescr}
                                    </MenuItem>
                                  );
                                })
                              : null}
                          </TextField>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                  <div className="col-sm-4">
                    <fieldset className="custom-fieldset">
                      <legend className="same-font-family" id="quarter_label">
                        Quarter<span className="mandatory"> *</span>{' '}
                      </legend>
                      <div className="form-wrapper p-0">
                        <div className="mui-custom-form with-select field-xl no-lbl">
                          <TextField
                            fullWidth
                            placeholder=""
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              maxLength: 6,
                              'aria-labelledby': 'quarter_label',
                            }}
                            required
                            name="quarter"
                            aria-labelledby="quarter_label"
                            value={reqFreezeInvoiceData?.quarter?.toUpperCase()}
                            onChange={handleFreezeInvoiceData}
                            onBlur={(e) =>
                              handleOnblurEvent('quarter', e.target.value)
                            }
                            className={
                              errorMsgsStore?.length > 0
                                ? _.map(errorMsgsStore, (l) =>
                                    l.field === 'quarter'
                                      ? 'mandate-fields'
                                      : null
                                  )
                                : null
                            }
                            helperText={[
                              ...new Set(
                                errorMsgsStore?.length > 0
                                  ? _.map(errorMsgsStore, (l) =>
                                      l.field === 'quarter' ? l.message : null
                                    )
                                  : null
                              ),
                            ]}
                            error={[
                              ...new Set(
                                errorMsgsStore?.length > 0
                                  ? _.map(errorMsgsStore, (l) =>
                                      l.field === 'quarter' ? l.message : null
                                    )
                                  : null
                              ),
                            ]}
                          />
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
              )}
              <div className="row">
                {reqFreezeInvoiceData.freezeInvoiceBy === 'IN' && (
                  <div className="col-sm-4">
                    <fieldset className="custom-fieldset">
                      <legend
                        className="same-font-family"
                        id="invoice_num_label"
                      >
                        Invoice Number<span className="mandatory"> *</span>{' '}
                      </legend>
                      <div className="form-wrapper p-0">
                        <div className="mui-custom-form with-select field-xl no-lbl">
                          <TextField
                            // label="Invoice Number"
                            fullWidth
                            required
                            placeholder=""
                            value={reqFreezeInvoiceData?.invoiceNum}
                            name="invoiceNum"
                            // inputProps={{ maxlength: 11 }}
                            onChange={handleFreezeInvoiceData}
                            onKeyPress={isNumber}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              maxLength: 38,
                              'aria-labelledby': 'invoice_num_label',
                            }}
                            onBlur={(e) =>
                              handleOnblurEvent('invoiceNum', e.target.value)
                            }
                            className={
                              errorMsgsStore?.length > 0
                                ? _.map(errorMsgsStore, (l) =>
                                    l.errorType === 'invoiceNum'
                                      ? 'mandate-fields'
                                      : null
                                  )
                                : null
                            }
                            helperText={[
                              ...new Set(
                                errorMsgsStore?.length > 0
                                  ? _.map(errorMsgsStore, (l) =>
                                      l.errorType === 'invoiceNum'
                                        ? l.message
                                        : null
                                    )
                                  : null
                              ),
                            ]}
                            error={[
                              ...new Set(
                                errorMsgsStore?.length > 0
                                  ? _.map(errorMsgsStore, (l) =>
                                      l.errorType === 'invoiceNum'
                                        ? l.message
                                        : null
                                    )
                                  : null
                              ),
                            ]}
                          />
                        </div>
                      </div>
                    </fieldset>
                  </div>
                )}
                {reqFreezeInvoiceData.freezeInvoiceBy === 'PQM' && (
                  <div className="col-sm-4">
                    <div className="mui-custom-form with-select input-md">
                      <div className="sub-radio text-black sub-label">
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="primary"
                              name="allManufacturers"
                              checked={reqFreezeInvoiceData?.allManufacturers}
                              onChange={(e) => {
                                handleFreezeInvoiceData(e);
                                    if (!e.target.checked) {
                                    searchManufacturers();
                                  }
                              }}
                            />
                          }
                          label="All Manufacturers"
                        />
                      </div>
                    </div>
                  </div>
                )}
                <div className="col-sm-8">
                  <div className="btn-wrapper mb-2">
                    <div className="float-right mt-2 hide-on-print">
                      {reqFreezeInvoiceData.freezeInvoiceBy === 'PQM' &&
                        !reqFreezeInvoiceData?.allManufacturers && (
                          <Button
                            className="btn-success same-font-family"
                            onClick={searchManufacturers}
                          >
                            <SVGComponent iconName="Icon-search" /> Search
                          </Button>
                        )}

                      <Button
                        className="btn-success same-font-family"
                        onClick={(e) => processFreezeInvoiceDate(e, 'N')}
                        /* disabled={
                          (reqFreezeInvoiceData?.freezeInvoiceBy === 'PQM' &&
                            !reqFreezeInvoiceData?.allManufacturers &&
                            selected == null) ||
                          (reqFreezeInvoiceData?.freezeInvoiceBy === 'IN' &&
                            (!reqFreezeInvoiceData?.invoiceNum ||
                              !reqFreezeInvoiceData?.freezeDate))
                        } */
                      >
                        <SVGComponent iconName="Icon-run-now" /> Run Now
                      </Button>
                      <Button
                        className="btn-success same-font-family"
                        onClick={(e) => processFreezeInvoiceDate(e, 'L')}
                        /*   disabled={
                          (reqFreezeInvoiceData?.freezeInvoiceBy === 'PQM' &&
                            !reqFreezeInvoiceData?.allManufacturers &&
                            selected == null) ||
                          (reqFreezeInvoiceData?.freezeInvoiceBy === 'IN' &&
                            (!reqFreezeInvoiceData?.invoiceNum ||
                              !reqFreezeInvoiceData?.freezeDate))
                        } */
                      >
                        <SVGComponent iconName="Icon-run-later" /> Run Later
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      {reqFreezeInvoiceData.freezeInvoiceBy === 'PQM' &&
        !reqFreezeInvoiceData?.allManufacturers && (
          <div className="panel tBillPanel-space pb-0">
            <div className="FRR-custom-table tbl-manufacturer-home">
              <Grid
                gridHeight={fullScreenView ? '100vh' : 350}
                rowData={manufacturersByPQR?.data || []}
                columnDefs={manuFactureHead}
                onGridReady={onGridReady}
                onSelect={onCellClicked}
                navigateToNextCell={navigateToNextCell}
                tabToNextCell={tabToNextCell}
                enterMovesDown
                suppressCellFocus
                onCellFocused={onCellFocused}
                applyFilter={false}
                exportFile
                childPopup
                data-testid="onEditingStopped"
                fileName="Freeze Invoice"
                fullScreenView={fullScreenView}
                handleFullScreenViewClick={handleFullScreenView}
                handleViewHistory={handleViewHistory}
              />
            </div>

            {showViewHistory && (
              <ViewHistoryComponent
                setShowViewHistory={setShowViewHistory}
                tableName="INVOICE_HEADER"
                keyValue={keyValue}
              />
            )}
          </div>
        )}
    </div>
  );
}
export default withRouter(FreezeInvoice);
